import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Paper, Checkbox, Grid, makeStyles } from "@material-ui/core";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import AdjustIcon from "@material-ui/icons/Adjust";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/react-state-lens";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "../styles";

const useStyles = makeStyles(clientPageStyle);

function IndividualCard({ isIndividualLens }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = useCallback((value) => () => (isIndividualLens |> set)(value), [isIndividualLens]);
  return (
    <Paper className={classes.filterStyle}>
      <Grid container>
        <Grid item>
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUncheckedIcon />}
                checkedIcon={<AdjustIcon />}
                checked={!(isIndividualLens |> get)}
                onChange={handleChange(false) |> onCheckBoxChange}
              />
            }
            label={t("Client.Company")}
          />
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUncheckedIcon />}
                checkedIcon={<AdjustIcon />}
                checked={isIndividualLens |> get}
                onChange={handleChange(true) |> onCheckBoxChange}
              />
            }
            label={t("Client.Individual")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

IndividualCard.propTypes = {
  isIndividualLens: PropTypes.object.isRequired,
};

export default IndividualCard;
